export default {
    "AdditionalPageTypes": true,
    "Admin": true,
    "Advertising": true,
    "Advertising2": {
        adServers: ["simple"],
        adSizes: ["mpu", "banner", "banner-large"]
    },
    "AggregatedContentFeed": true,
    "AllowCustomFields": true,
    "AppConfig": true,
    "AppEcommerceManager": true,
    "AppScorePredictor": true,
    "AppSocialManager": true,
    "AppStadiumFinder": true,
    "AppTicketingManager": true,
    "Blog": true,
    "BreakingNews": true,
    "Broadcasters": true,
    "BuildManager": true,
    "Calendar": true,
    "Clubs": true,
    "CustomCommentary": true,
    "CustomLineups": true,
    "CustomTags": true,
    "CustomTables": true,
    "Dashboard": true,
    "Docs": true,
    "Fixtures": true,
    "Forms": true,
    "HomepageManager": true,
    "HomepageNewsPromo": true,
    "HomepagePlayerHighlight": true,
    "Lab": true,
    "MapDirectory": true,
    "MatchdayTakeover": true,
    "Media": true,
    "MFA": true,
    "News": true,
    "OneFootballIntegration": true,
    "OptaIntegration": true,
    "Organisations": true,
    "OverlayPromos": true,
    "Pages": true,
    "PagesAltTitles": true,
    "PlatformOptions": true,
    "PlayerVoting": true,
    "PreventEntitlementEmails": false,
    "Profile": true,
    "RelatedContentTagging": true,
    "RewardsManager": true,
    "RewardPoints": true,
    "Rover": true,
    "Settings": false,
    "SiteConfig": true,
    "SocialContentFeed": true,
    "Sponsors": true,
    "Squads": true,
    "SsoUsers": true,
    "StreamAMGIntegration": true,
    "Streamline": true,
    "StreamlineAdverts": true,
    "StreamlineSubtitles": true,
    "StreamlineAutoSubtitles": true,
    "StreamlinePromoCodes": true,
    "TeamCrestManager": true,
    "Videos": true,
    "Voice": true,
    "WebStats": true
}
